import { render, staticRenderFns } from "./list-prize.vue?vue&type=template&id=0e8b85d2"
import script from "./list-prize.vue?vue&type=script&lang=js"
export * from "./list-prize.vue?vue&type=script&lang=js"
import style0 from "./list-prize.vue?vue&type=style&index=0&id=0e8b85d2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports